module.exports = __webpack_public_path__ + "static/team_1-2ed552c7dbc14db775ca434717b928fe.jpg";